import { create } from 'zustand'

export interface ConfirmOptions {
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  /** Renders the confirm action in the destructive style. */
  destructive?: boolean
}

interface ConfirmRequest extends ConfirmOptions {
  resolve: (confirmed: boolean) => void
}

interface ConfirmState {
  request: ConfirmRequest | undefined
  open: (options: ConfirmOptions) => Promise<boolean>
  settle: (confirmed: boolean) => void
}

export const useConfirmStore = create<ConfirmState>((set, get) => ({
  request: undefined,
  open: (options) =>
    new Promise<boolean>((resolve) => {
      // A pending dialog is declined so its caller never hangs.
      get().request?.resolve(false)
      set({ request: { ...options, resolve } })
    }),
  settle: (confirmed) => {
    const { request } = get()
    if (!request) return

    request.resolve(confirmed)
    set({ request: undefined })
  },
}))

/**
 * Promise-based replacement for `window.confirm`, which blocks the main thread
 * and cannot be styled or tested.
 */
export function confirmAction(options: ConfirmOptions): Promise<boolean> {
  return useConfirmStore.getState().open(options)
}
